module.exports = __webpack_public_path__ + "static/media/SWSCRC1-02.39ffd830.mp3";